export default __webpack_public_path__ + "static/media/honey2.95c339ae.webp";